module.exports = __webpack_public_path__ + "img/icon-tooltip.2675dcc4.svg";